module.exports = __webpack_public_path__ + "img/manda_025.ab563740.png";